<template>
  <hmd-font v-if="status === 'READY'" type="warning">未开始</hmd-font>
  <hmd-font v-if="status === 'UPLOADING'" type="primary">上传中</hmd-font>
  <hmd-font v-if="status === 'SUCCESS'" type="success">上传成功</hmd-font>
  <hmd-font v-if="status === 'FAIL'" type="primary" danger>上传失败</hmd-font>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { UploadStatus } from "@/core/services/file-upload.interface";

export default defineComponent({
  name: "FileStatus",
  props: {
    status: {
      type: String as PropType<UploadStatus>,
      default: "",
    },
  },
});
</script>
